export const DIRECT_CALL_RULES = {
  NEW_PAGE_VIEW: 'newPageView',
  NEW_PROJECT_VIEW: 'projectView',
};
